import React, { useState } from 'react';
import { Header } from './components/Header';
import { Dashboard } from './components/Dashboard';
export const App: React.FC = () => {
  const [timeRange, setTimeRange] = useState('30d');
  return <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-blue-50" data-id="element-0" data-mp="3k8jhzgoph0nl">
      <Header timeRange={timeRange} setTimeRange={setTimeRange} data-id="element-1" data-mp="3f9ydh52f7utc" />
      <main className="container mx-auto px-4 py-6" data-id="element-2" data-mp="3f8nedijx7b8k">
        <Dashboard timeRange={timeRange} data-id="element-3" data-mp="2rlozuqfd2dda" />
      </main>
    </div>;
};